<app-loader />
<app-socket-route-manager />
<router-outlet></router-outlet>
